export default __webpack_public_path__ + "static/media/gilboa1.e7ddfbbd.jpg";